<template>
	<div id="app">
		<BHLoading :show="$store.state.features.loadingPage" />
		<MediaSelector />
		<router-view />
	</div>
</template>

<script>
import BHLoading from 'bh-mod/components/common/Loading'
import MediaSelector from 'bh-mod/components/file/MediaSelector'

export default {
	name: 'app',
	components: { BHLoading, MediaSelector },
	watch: {
		'$route'(to, from) {
			const query = Object.assign({}, to.query)
			this.$store.commit('SETUP_URL_SETTINGS', query)
		},
	},
}
</script>
<style>
#app {
	min-height: 100vh;
}

.ant-drawer-body {
	padding: 0;
	margin: 0;
}

iframe {
	border: 0;
}

.ant-drawer-header-no-title [aria-label="Close"] {
	background: white;
}
</style>
